import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center mt-3" },
    [
      _vm.worksheetTypeFields.hasTargetWeight
        ? _c(VTextField, {
            staticClass: "mx-auto",
            staticStyle: { "max-width": "200px", "font-size": "26px" },
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.targetWeight"),
              outlined: "",
              type: "number",
              inputmode: "decimal",
              min: "0",
            },
            on: {
              change: function ($event) {
                return _vm.$emit("update:worksheet", _vm.worksheet)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.productInfo ? _vm.productInfo.measureWeight : ""
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              631880013
            ),
            model: {
              value: _vm.worksheet.targetWeight,
              callback: function ($$v) {
                _vm.$set(_vm.worksheet, "targetWeight", _vm._n($$v))
              },
              expression: "worksheet.targetWeight",
            },
          })
        : _vm._e(),
      _vm.worksheetTypeFields.hasDeductibleWeight
        ? _c(VTextField, {
            staticClass: "mx-auto",
            staticStyle: { "max-width": "200px", "font-size": "26px" },
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.deductibleWeight"),
              outlined: "",
              type: "number",
              inputmode: "decimal",
              min: "0",
            },
            on: {
              change: function ($event) {
                return _vm.$emit("update:worksheet", _vm.worksheet)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.productInfo ? _vm.productInfo.measureWeight : ""
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              631880013
            ),
            model: {
              value: _vm.worksheet.deductibleWeight,
              callback: function ($$v) {
                _vm.$set(_vm.worksheet, "deductibleWeight", _vm._n($$v))
              },
              expression: "worksheet.deductibleWeight",
            },
          })
        : _vm._e(),
      _vm.worksheetTypeFields.hasNetAdjustmentWeight
        ? _c(VTextField, {
            staticClass: "mx-auto",
            staticStyle: { "max-width": "200px", "font-size": "26px" },
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.netAdjustmentWeight"),
              outlined: "",
              type: "number",
              inputmode: "decimal",
              min: "0",
            },
            on: {
              change: function ($event) {
                return _vm.$emit("update:worksheet", _vm.worksheet)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.productInfo ? _vm.productInfo.measureWeight : ""
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              631880013
            ),
            model: {
              value: _vm.worksheet.netAdjustmentWeight,
              callback: function ($$v) {
                _vm.$set(_vm.worksheet, "netAdjustmentWeight", _vm._n($$v))
              },
              expression: "worksheet.netAdjustmentWeight",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-4" },
        [
          _c(
            VBtn,
            {
              attrs: {
                disabled: _vm.worksheet.status == "USED",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }